import type React from 'react'

import css from './styles.module.css'

interface Props {
  src: string
}

export const ImageAccessory: React.FC<Props> = ({ src }) => (
  <img alt="" className={css.image_accessory} src={src} />
)
